(function() {
    'use strict';
    angular
        .module('doctorclubboApp')
        .factory('Campagnalog_tipo', Campagnalog_tipo);

    Campagnalog_tipo.$inject = ['$resource'];

    function Campagnalog_tipo ($resource) {
        var resourceUrl =  'api/campagnalog-tipos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
